import axios from 'axios';
import constants from 'config/constants';
import { getLocalStore } from 'utils/commonFunc';

export const GET_ACTIVITY_MODULES = 'GET_ACTIVITY_MODULES';
export const getActivitiesModules = modules => ({
  type: GET_ACTIVITY_MODULES,
  modules,
});

export const GET_RECENT_ACTIVITIES = 'GET_RECENT_ACTIVITIES';
export const getRecentActivities = (recentActivities, limit) => ({
  type: GET_RECENT_ACTIVITIES,
  recentActivities,
  limit,
});

export const GET_ACTIVITY_BY_FILTER = 'GET_ACTIVITY_BY_FILTER';
export const getActivitiesByFilter = filterActivities => ({
  type: GET_ACTIVITY_BY_FILTER,
  filterActivities,
});

export const GET_VOICE_CALLS = 'GET_VOICE_CALLS';
export const getVoiceCalls = voiceCalls => ({
  type: GET_VOICE_CALLS,
  voiceCalls,
});

export const fetchActivitiesModulesService = data => async dispatch => {
  const { schoolId, token } = data;
  try {
    const res = await axios.get(
      `${constants.API_BASE_URL}/api/admin/audit-log-modules/${schoolId}`,
      constants.setHeader(token)
    );
    dispatch(getActivitiesModules(res.data));
  } catch (err) {
    console.error('err-fetchActivitiesModulesService', err);
  }
};

export const fetchRecentActivitiesService = data => async dispatch => {
  const { schoolId, token, limit = 10 } = data;
  try {
    const res = await axios.get(
      `${constants.API_BASE_URL}/api/admin/recent-audit-log/${schoolId}/${limit}`,
      constants.setHeader(token)
    );
    dispatch(getRecentActivities(res.data, limit));
  } catch (err) {
    console.error('err-fetchActivitiesModulesService', err);
  }
};

export const fetchActivitiesByFilterService = data => async dispatch => {
  const { schoolId, token, filterData } = data;
  try {
    const res = await axios.post(
      `${constants.API_BASE_URL}/api/admin/audit-log-by-filter/${schoolId}/${filterData?.page}/${filterData?.limit}`,
      filterData,
      constants.setHeader(token)
    );
    dispatch(getActivitiesByFilter(res.data, filterData?.page));
  } catch (err) {
    console.error('err-fetchActivitiesModulesService', err);
  }
};

export const sendVoiceOrActivityService = data => () => {
  const { schoolId, formData = '', token, auditDescription = '' } = data;
  const url = formData
    ? `api/admin/upload-voice-record/${schoolId}`
    : `api/admin/audit-emergency-announcement/${schoolId}`;
  return axios({
    method: 'post',
    url: `${constants.API_BASE_URL}/${url}`,
    data: formData || { auditDescription, schoolId },
    headers: {
      ...constants.setHeader(token)?.headers,
      ...(formData && { 'Content-Type': 'multipart/form-data' }),
    },
  });
};

export const updateAnnouncementActivityService = data => () => {
  const { schoolId, auditLogId, auditDescription, token } = data;
  return axios({
    method: 'put',
    url: `${constants.API_BASE_URL}/api/admin/audit-emergency-announcement/${schoolId}/${auditLogId}`,
    data: { auditDescription },
    headers: constants.setHeader(token)?.headers,
  });
};

export const fetchVoiceCallsService = data => async dispatch => {
  const loggedUser = getLocalStore('loggedUser');
  const { userRole = '' } = loggedUser || {};
  const { schoolId, pageParams, token } = data;
  const url =
    userRole === constants.roles.teacher
      ? 'api/admin/get-all-teacher-guard-voice-record'
      : 'api/admin/get-all-admin-voice-record';
  try {
    const res = await axios.get(
      `${constants.API_BASE_URL}/${url}/${schoolId}${constants.makeParams(pageParams)}`,
      constants.setHeader(token)
    );
    dispatch(getVoiceCalls(res.data));
  } catch (err) {
    console.error('err-fetchActivitiesModulesService', err);
  }
};
